export default __webpack_public_path__ + "static/avatar-ca83ab17e2f2f09aedccfc557e577368.jpg";